import { Col, Flex, Row } from "antd";
import ButtonComponent from "components/button/Button";
import DropdownTriangle from "components/dropdown-triangle";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import PopupConfirm from "components/popup-confirm";
import { apiGetNotices, apiUpdateStatusNotices } from "helpers/api/notices";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { showToastError, showToastSuccess } from "utils";
import { NOTICE_ACTION } from "./constants";
import Notices from "./notice-items";
import "./styles.scss";

const NoticesList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selected, setSelected] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [loading, setLoading] = useState(0);
  const [notices, setNotices] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });

  const getNotices = (newPage) => {
    setLoading((prev) => prev + 1);
    apiGetNotices({
      page: newPage || notices.page,
      limit: 15,
      key_search: searchInput,
    })
      .then((res) => {
        if (res.error) {
          showToastError(res.error.message);
        } else {
          setNotices(res);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const handleAction = (item) => {
    if (selected.length) {
      if (item.value === NOTICE_ACTION.DELETE) {
        setIsOpenDelete(true);
      } else {
        handleStatus(item.value);
      }
    }
  };

  const handleStatus = (type) => {
    setIsOpenDelete(false);
    setLoading((prev) => prev + 1);
    apiUpdateStatusNotices({
      notice_ids: selected,
      type,
    })
      .then((res) => {
        if (res.error) {
          showToastError(res.error.message);
        } else {
          if (type === NOTICE_ACTION.PUBLISH) {
            showToastSuccess("messages.MSG-USP060");
          }
          if (type === NOTICE_ACTION.UNPUBLISH) {
            showToastSuccess("messages.MSG-USP062");
          }
          if (type === NOTICE_ACTION.DELETE) {
            showToastSuccess("messages.MSG-USP045");
            if (selected.length === notices.data.length) {
              getNotices(1);
            } else {
              getNotices();
            }
            setSelected([]);
            return;
          }
          getNotices();
          setSelected([]);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  useEffect(() => {
    getNotices();
  }, []);

  return (
    <div className="notice-container main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("admin_role")}</div>
      </div>
      <div className="nav">
        <Flex gap="large" wrap="wrap" align="center">
          <div className="screen-title">{t("notices.title")}</div>
          <DropdownTriangle
            options={[
              {
                title: "notices.publishSelectedArticles",
                value: NOTICE_ACTION.PUBLISH,
              },
              {
                title: "notices.hideSelectedArticles",
                value: NOTICE_ACTION.UNPUBLISH,
              },
              {
                title: "notices.deleteSelectedArticles",
                value: NOTICE_ACTION.DELETE,
              },
            ]}
            onClick={handleAction}
          />
        </Flex>
        <Row className="notice-header">
          <Col md={7}>
            <InputComponent
              placeholder={t("search")}
              onChange={(e) => setSearchInput(e.target.value)}
              onEnter={() => getNotices(1)}
              suffix={
                <img
                  alt=""
                  src="/icons/search_img.png"
                  className="ic x2"
                  onClick={() => getNotices(1)}
                />
              }
            />
          </Col>
          <Col offset={1}>
            <ButtonComponent
              background="#B4E0F3"
              className="btn-create"
              text={t("notices.createArticle")}
              onClick={() => history.push("/admin/notices/create")}
            />
          </Col>
        </Row>
      </div>
      <Notices
        data={notices.data}
        selected={selected}
        setSelected={setSelected}
      />
      {notices.data.length &&
      <Row
        style={{
          marginTop: "20px",
          justifyContent: "flex-end",
          padding: "0 20px",
        }}
      >
        <Col style={{ display: "flex" }}>
          {console.log(notices)}
          {`${notices.page}/${notices.total_page} ${t("notices.page")}　`}
          <Flex gap="10px">
            {notices.page > 1 ? (
              <span
                style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                onClick={() => {
                  setNotices((prev) => ({ ...prev, page: prev.page - 1 }));
                  getNotices(notices.page - 1);
                }}
              >
                ▶
              </span>
            ) : null}
            {notices.page < notices.total_page ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setNotices((prev) => ({ ...prev, page: prev.page + 1 }));
                  getNotices(notices.page + 1);
                }}
              >
                ▶
              </span>
            ) : null}
          </Flex>
        </Col>
      </Row>
      }
      <PopupConfirm
        open={isOpenDelete}
        onCancelText={t("button.cancel")}
        onOkText={t("button.delete")}
        content={t("confirm_delete")}
        onOk={() => handleStatus(NOTICE_ACTION.DELETE)}
        onCancel={() => setIsOpenDelete(false)}
        onOkColor="#FF3131"
      />
      {loading ? <Loading /> : null}
    </div>
  );
};

export default NoticesList;
